/**
 * friDay Mweb Configurations
 */

const isBeta = /(best-uat|localhost)/i.test(location.host);
const isMobile = /mobile/i.test(navigator.userAgent);

module.exports = {
  siteId: () => {
    return isBeta ? 'BW473485' : 'BW831033';
  },
  injectMockData: true, // for dev mode. if true and inject mock
  webCacheExpireTime: 300,
  ecDomain: () => {
    const subdomain = isBeta
      ? isMobile
        ? 'ec2-muat2'
        : 'ec2-uat2'
      : isMobile
      ? 'ec-m'
      : 'ec-w';
    return `https://${subdomain}.shopping.friday.tw/`;
  },
  subDomain: () => {
    let sub = 'best';
    if (isBeta) {
      sub = 'best-uat';
    }
    return sub;
  },
  title: 'friDay嚴選',
  description:
    '【friDay嚴選】是friDay購物專為美安會員成立的專屬購物網站，週週嚴選數十樣商品，提供更優惠的價格及更高的現金回饋，【friDay嚴選】及【friDay購物】永遠是美安會員網路購物的最佳選擇！',
  apiPath: (cusApiRoot) => {
    let schema = 'https://';
    let subdomain = '';
    let domain = '.shopping.friday.tw';
    let apiRoot = '/mobileapi/';
    if (isBeta) {
      subdomain = 'best-uat';
    } else {
      subdomain = 'best';
    }

    if (cusApiRoot) {
      apiRoot = cusApiRoot;
    }

    return schema + subdomain + domain + apiRoot;
  },
  // EC地端API
  frontApiPath: (cusApiRoot) => {
    let schema = 'https://';
    let subdomain = 'front';
    let domain = '.shopping.friday.tw';
    let apiRoot = '/frontendapi/';
    if (isBeta) subdomain = 'front-uat2';
    if (cusApiRoot) apiRoot = cusApiRoot;
    return schema + subdomain + domain + apiRoot;
  },
  // EC雲端API
  frontCloudApiPath: (cusApiRoot) => {
    let schema = 'https://';
    let subdomain = 'frontend-gateway';
    let domain = '.shopping.friday.tw';
    let apiRoot = '/frontendapi/';
    if (isBeta) subdomain = 'frontend-gateway-dev';
    if (cusApiRoot) apiRoot = cusApiRoot;
    return schema + subdomain + domain + apiRoot;
  },
  // AI雲端API
  aiCloudApiPath: (cusApiRoot) => {
    let schema = 'https://';
    let subdomain = 'k8aiapi';
    let domain = '.shopping.friday.tw';
    let apiRoot = '/api/';
    if (isBeta) subdomain = 'aiapi-sit';
    if (cusApiRoot) apiRoot = cusApiRoot;
    return schema + subdomain + domain + apiRoot;
  },
  loginUrl: () => {
    const subDomain = isBeta
      ? isMobile
        ? 'ec2-muat2.'
        : 'ec2-uat2.'
      : isMobile
      ? 'm.'
      : '';
    const path = isMobile ? '/mobileweb/login' : '/ec2/login';
    const domain = 'shopping.friday.tw';
    return (
      'https://' +
      subDomain +
      domain +
      path +
      '?requestURL=' +
      encodeURIComponent(location.href)
    );
  },
  loggoutUrl: () => {
    const dev = /ec2-(sit|sit2|uat)/i.test(location.origin) ? '-test' : '';
    return `https://member${dev}.friday.tw/fri/sso/logout?post_logout_redirect_uri=${location.origin}/mobileweb/logout`;
  },
  sid: () => {
    let sid = 879;
    if (/(best-uat|best-sit|localhost|10\.100)/i.test(location.host)) {
      sid = 879;
    }
    if (/best-sit/i.test(location.host)) {
      sid = 879;
    }
    return sid;
  },
};
